import { render, staticRenderFns } from "./ProductSample.vue?vue&type=template&id=629b87ca&scoped=true"
import script from "./ProductSample.vue?vue&type=script&lang=js"
export * from "./ProductSample.vue?vue&type=script&lang=js"
import style0 from "./ProductSample.vue?vue&type=style&index=0&id=629b87ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b87ca",
  null
  
)

export default component.exports